/* Dynamically import modules as they are needed */

function loadRedirects() {
  /* Load the module only when a request hits the root and provides a hash. */
  if (document.location.pathname === '/' && document.location.hash) {
    return import(
      /* webpackChunkName: 'redirect' */ './redirect'
    ).then(({ default: watchForLegacyURL }) => watchForLegacyURL());
  }
  return false;
}

function loadArticles() {
  /* Load these modules only when a request is about an article. */
  if ($('.js-article-content').length === 1) {
    import(
      /* webpackChunkName: 'article' */ './article_a_z_sidebar'
    ).then(({ default: applyAZSidebarEventHandler }) =>
      applyAZSidebarEventHandler()
    );
    import(
      /* webpackChunkName: 'article' */ './infobox'
    ).then(({ default: applyInfoboxClickHandler }) =>
      applyInfoboxClickHandler()
    );

    import(
      /* webpackChunkName: 'article' */ './photoswipe'
    ).then(({ default: initPhotoSwipeFromDOM }) => initPhotoSwipeFromDOM());

    import(
      /* webpackChunkName: 'article' */ './swipe'
    ).then(({ default: swipeHandler }) => swipeHandler());

    import(
      /* webpackChunkName: 'article' */ './the_week'
    ).then(({ default: theWeekHandler }) => theWeekHandler());
  }
  return false;
}

function loadIssue() {
  /* Load these module that are issue related */
  if ($('.js-reveal-container')) {
    import(
      /* webpackChunkName: 'issue' */ './message'
    ).then(({ default: applyMessageClickHandler }) =>
      applyMessageClickHandler()
    );

    import(
      /* webpackChunkName: 'issue' */ './reveal'
    ).then(({ default: applyRevealEventHandler }) => applyRevealEventHandler());
  }
  return false;
}

function loadScrolling() {
  /* Load these module that are related to views that need endless scrolling */
  if ($('.js-infinite-container').length === 1) {
    return import(
      /* webpackChunkName: 'scroll' */ './scrolling'
    ).then(({ default: infiniteScrolling }) => infiniteScrolling());
  }
  return false;
}

function defaultNonCritical() {
  /* Load these modules always, load them async as they are not critical */
  import(
    /* webpackChunkName: 'default' */ './search'
  ).then(({ default: search }) => search());
  import(
    /* webpackChunkName: 'default' */ './social'
  ).then(({ default: social }) => social());
  import(
    /* webpackChunkName: 'default' */ './bookmarks'
  ).then(({ default: bookmarks }) => bookmarks());
  import(
    /* webpackChunkName: 'default' */ './navigation'
  ).then(({ default: navigation }) => navigation());
  import(
    /* webpackChunkName: 'default' */ './menu_icon'
  ).then(({ default: menu_icon }) => menu_icon());
  return false;
}

export default function loadAsyncModules() {
  loadRedirects();
  loadArticles();
  loadIssue();
  loadScrolling();
  defaultNonCritical();
}
